// componente para los contactos que tiene el cliente


// react importation
import { useContext } from "react";


// components importation
import { LoadingComp } from "../../components/loading-comp/LoadingComp.jsx";



// custom hook contacts
import { useFetchCont } from "../../customs-hooks/contacts/useFetchCont.js";


// import userContext
import { UserContext } from "../../context/UserContext.jsx";
import { useTranslation } from "react-i18next";





export const ContactsView = () => {


  // useContext 
  const { user } = useContext(UserContext);


  const { contacts, state } = useFetchCont(user.CodCliente);

  // GET the language
  const [t] = useTranslation("global");


  return (
    <>

      {
        state.isLoading && (
          <LoadingComp />
        )
      }
      <div className="container">

        <table className="table">
          <thead className="table-head">
            <tr>
              <th>{t("Contacts.nombre")}</th>
              <th>{t("Contacts.telefono")}</th>
              <th>{t("Contacts.celular")}</th>
              <th>{t("Contacts.correo")}</th>
              <th>{t("Contacts.depart")}</th>
              <th>{t("Contacts.cargo")}</th>
              <th>{t("Contacts.principal")}</th>
            </tr>
          </thead>
          <tbody className="table-body">
            {
              contacts && contacts.map((cont) => (
                <tr key={cont.CodContacto}>
                  <td>{cont.Nombre}</td>
                  <td>{cont.CodTelefono} {cont.Telefono}</td>
                  <td>{cont.CodCelular} {cont.Celular}</td>
                  <td className="email-txt">{cont.Correo}</td>
                  <td>{cont.Departamento}</td>
                  <td>{cont.Cargo}</td>
                  <td>{cont.PrincipalT}</td>
                </tr>
              ))
            }
          </tbody>
        </table>

      </div>
    </>
  );
}; 